export enum PreferredContactMethod {
	Cellphone = 1,
	Email = 2,
}

// Required for External User Email Confirmation type
export enum ExternalUserConfirmationType {
	Reject = "reject",
	Approve = "approve",
}

export enum ExternalUserType {
	Administrator = 1,
	User = 0,
}

export enum ExternalUserStatus {
	Pending = "Pending",
	Active = "Active",
	InActive = "InActive",
	Rejected = "Rejected",
	Deleted = "Deleted",
}

export enum CellphoneCode {
	IN = "+91",
	SA = "+27",
}
